import { render, staticRenderFns } from "./TableDotsOverlay.vue?vue&type=template&id=b8918222&scoped=true"
import script from "./TableDotsOverlay.vue?vue&type=script&lang=js"
export * from "./TableDotsOverlay.vue?vue&type=script&lang=js"
import style0 from "./TableDotsOverlay.vue?vue&type=style&index=0&id=b8918222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8918222",
  null
  
)

export default component.exports